import { render } from "./PlayerRoster.vue?vue&type=template&id=5b2bddde"
import script from "./PlayerRoster.vue?vue&type=script&lang=js"
export * from "./PlayerRoster.vue?vue&type=script&lang=js"

import "./PlayerRoster.vue?vue&type=style&index=0&id=5b2bddde&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__